import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import AnonymousLayout from "./AnonymousLayout";
import MainLayout from "./MainLayout";

const RouteLayout = ({
  element: Component,
  loginRequired,
  hideLogoHeader,
  hideFooter,
}) => {
  const { isAuthenticated, isInitialized } = useAuth();
  const isLoginRequired = loginRequired;

  const renderLayout = () => {
    if(isInitialized) {
      if (isAuthenticated) {
        return (
            <MainLayout hideLogoHeader={hideLogoHeader} hideFooter={hideFooter}>
              <Component />
            </MainLayout>
        );
      } else {
        if (isLoginRequired) {
          return <Navigate to={{ pathname: ROUTE_PATHS.SignIn }} />;
        }
        return (
          <AnonymousLayout hideLogoHeader={hideLogoHeader}>
            <Component />
          </AnonymousLayout>
        );
      }
    }
   
  };

  return renderLayout();
};

export default RouteLayout;
